<<template>
    <div>
        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="!isLoading && influencer === null"
        >
            <div class="alert-body">
                Influencer Bulunamadı
                <b-link
                    class="alert-link"
                    :to="{ name: 'influencers' }"
                >
                    Influencer
                </b-link>
                sayfasını görüntüle
            </div>
        </b-alert>

        <loading-card v-if="isLoading"></loading-card>
        <div v-else-if="influencer !== null">
            <b-card
                no-body
                class="invoice-preview-card invoice-preview"
            >

                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">
                    <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <!-- Header: Left Content -->
                        <div>
                            <div class="logo-wrapper">
                                <h3 class="text-primary">
                                    {{ influencer.name_surname || 'Fenomen Adı Bulunamadı' }}
                                </h3>
                            </div>
                            <b-col
                                cols="12"
                                class="p-0"
                            >
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td class="pr-1">Profili :</td>
                                                <td>{{ influencer.username || 'Kullanıcı Adı' }}</td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">E-Mail adresi :</td>
                                                <td>{{ influencer.email || 'Kullanıcı Adı' }}</td>
                                            </tr>
                                            <tr>
                                                <td class="pr-1">Telefon Numarası :</td>
                                                <td>{{ influencer.phone || 'Kullanıcı Adı' }}</td>
                                            </tr>
                                            <tr class="text-success" v-if="influencer.id!=1">
                                                <td class="pr-1">Link İçi Oran :</td>
                                                <td class="font-weight-bold">
                                                    %{{ influencer.link_ici_odeme_orani || 0 }}
                                                </td>
                                            </tr>
                                            <tr class="text-danger" v-if="influencer.id!=1">
                                                <td class="pr-1">Link Dışı Oran :</td>
                                                <td class="font-weight-bold">
                                                    %{{ influencer.link_disi_odeme_orani || 0 }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-col>
                        </div>

                        <!-- Header: Right Content -->
                        <div class="mt-md-0 mt-2">
                            <h4 class="invoice-title">
                                Fenomen ID:
                                <span class="invoice-number">
                                    #{{ influencer.unique_token || 'Bulunamadı' }}
                                </span>
                            </h4>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Kayıt Tarihi:</p>
                                <p class="invoice-date">
                                    {{ formatDate(influencer.created_date) || 'Tarih Yok' }}
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Onaylama Tarihi:</p>
                                <p class="invoice-date" v-if="influencer.verify_date">
                                    {{ formatDate(influencer.verify_date) || 'Tarih Yok' }}
                                </p>
                                <p class="invoice-date" v-else>
                                    <span class="text-danger">Onaylanmamış</span>
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Durum:</p>
                                <p class="invoice-date semibold">
                                    <b-badge v-if="!influencer.deleted" variant="success">Aktif</b-badge>
                                    <b-badge v-else variant="danger">Pasif</b-badge>
                                </p>
                            </div>
                        </div>
                    </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Invoice Client & Payment Details -->
                <b-card-body
                    class="invoice-padding pt-0"
                >
                    <b-row class="invoice-spacing">
                        <b-col
                            md="12"
                        >
                            <global-summary :infId="inf_id" />
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>

            <!-- <apex-line-area-chart :inf_id="inf_id"/> -->

            <echart-stacked-area
                :inf_id="inf_id"
            />
            
            <b-tabs
                v-if="influencer"
                pills
                >

                <!-- İlgili Paylaşımlar -->
                <b-tab active @click="isActiveTab='campaigns'">
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Paylaşımlar</span>
                    </template>
                    <campaign-list v-if="isActiveTab === 'campaigns' && inf_id" :tableColumns="tableColumnsLinks" :InfId="inf_id" ></campaign-list>
                </b-tab>

                <!-- İlgili Siparişler -->
                <b-tab>
                    <template #title>
                    <feather-icon
                        icon="ShoppingCartIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Siparişler</span>
                    </template>
                    <orders :tableColumns="tableColumns" :params="orderParams" @orders-fetched="handleOrdersFetched" :title="influencer.name_surname+ ' Siparişleri'"></orders>
                </b-tab>

                
                <!-- İlgili ÜRünler -->
                <b-tab @click="isActiveTab='products'">
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Ürünler</span>
                    </template>
                    <products
                    v-if="isActiveTab === 'products' && inf_id" :params="orderParams" :title="influencer.name_surname+ ' Satılan ürünler'" ></products>
                </b-tab>

            </b-tabs>
        </div>
    </div>
</template>


<script>
    import { BRow, BAlert,BBadge,BCardTitle, BCol, BCard, BCardHeader, BCardBody, BTab, BTabs } from 'bootstrap-vue';
    import LoadingCard from '@/layouts/components/isLoading.vue';
    import Orders from './Orders.vue';
    import GlobalSummary from '@/components/GlobalSummary.vue';
    import CampaignList from './campaign/Links.vue';
    import Products from './Products.vue';
    import ApexLineAreaChart from '@/components/charts-components/ApexLineAreaChart.vue';
    import EchartStackedArea from '@/components/charts-components/EchartStackedArea.vue';
    export default {
        components: {
            BRow,
            BCol,
            BCard,
            BCardHeader,
            BCardBody,
            BAlert,
            BBadge,
            BCardTitle,
            BTab,
            BTabs,

            LoadingCard,
            Orders,
            GlobalSummary,
            CampaignList,
            Products,
            ApexLineAreaChart,
            EchartStackedArea
        },
        data() {
            return {
                isLoading : true,
                influencer: {},
                campaigns:[],
                inf_id:this.$route.params.id,
                orderParams:{
                    infId:this.$route.params.id,
                },
                isActiveTab: 'campaigns',
                tableColumns : [
                    { key: 'id', sortable: true },
                    { key: 'created_date', label: 'Sipariş Tarihi', sortable: true },
                    { key: 'link', label: 'Paylaşım', sortable: true },
                    { key: 'transaction', label: 'Sipariş No', sortable: true },
                    { key: 'amount', label: 'Toplam', sortable: true },
                    { key: 'inf_payment_total', label: 'Ödenecek Tutar', sortable: true },
                    { key: 'order_status', label: 'Sipariş Durumu', sortable: true },
                    { key: 'vesting_status', label: 'Hakediş Durumu'},
                    { key: 'show_details', label: 'DETAY'},
                ],
                tableColumnsLinks : [
                    { key: 'id', sortable: true },
                    { key: 'campaign_name', label: 'Paylaşım', sortable: true },
                    { key: 'start_date',label:'Başlama Tarihi', sortable: false },
                    { key: 'end_date',label:'Bitiş Tarihi', sortable: false },
                    { key: 'order_count',label:'Sipariş Adedi', sortable: false },
                    { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
                    { key: 'status', label: 'Durum'},
                    { key: 'actions', label: 'İşlem'},
                ],
            }
        },
        methods: {
            handleOrdersFetched(orders=null) {
                
               console.log(orders)

            },
            getInfluencer () {
                this.$http.get('/user', {
                    params: {
                        id: this.inf_id,
                        user_type: 'influencer',
                        source: 'detail',
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.influencer=response.data.data[0]
                    }
                    this.isLoading=false
                })
            },
        },
        mounted () {
            this.getInfluencer();
        },
    }
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
<style lang="scss" scoped>

</style>>